import '.cd{display:inline-flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.jm{padding:0.6rem;}.ssr-plugin'
import '.hm{border-radius:1.875rem;}.ssr-plugin'
import '.jn{border:1px solid var(--palette-blue-50);}.ssr-plugin'
import '.jo{box-shadow:0 1rem 2rem 0.5rem var(--palette-blue-50);}.ssr-plugin'
import '.jp{--page-min-height:auto;}.ssr-plugin'
import '.dn{border-radius:2rem;}.ssr-plugin'
import '.jq{overflow-x:hidden;}.ssr-plugin'
import '.be{overflow-y:auto;}.ssr-plugin'
import '.jr{background:var(--page-bg);}.ssr-plugin'
import '.aq{position:relative;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { ReactNode } from 'react'

export type PhoneFrameProps = {
  children: ReactNode
  width?: number
  height?: number
  style?: Style
}

export const PhoneFrame = ({
  children,
  width = 390,
  height = 760,
  style,
}: PhoneFrameProps) => {
  return (
    <styled.div className="cd e t v jm hm jn jo"
      style={{
        ...style,
      }}
    >
      <styled.div className="jp dn jq be jr aq"
        style={{
          width,
          height,} as Style}
      >
        <div style={{ pointerEvents: 'none' }}>{children}</div>
      </styled.div>
    </styled.div>
  )
}
